import React, { Fragment } from "react";
import { StepRenderProps } from "../../../interfaces/FlowInterfaces";
import { createStyles, Divider, makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { MainOrganizationDetailsStepValues } from "../../_interfaces/IOrganizationSignUpStepTypeValues";
import { IOrganizationSignUpFlowValues } from "../../_interfaces/IOrganizationSignUpFlowValues";
import { OrganizationPrimaryDetailsForm } from "../../../../authentication/components/OrganizationPrimaryDetailsForm";
import { DemoRequest } from "./DemoRequest";
import { useMainOrganizationDetailsController } from "../../hooks/useMainOrganizationDetailsController";
import { OrganizationSignUpHeader } from "../OrganizationSignUpHeader";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        divider: {
            marginTop: theme.spacing(3),
            margin: 'auto',
            maxWidth: 400
        },
    })
);

export const MainOrganizationDetailsStep: React.FC<
    StepRenderProps<MainOrganizationDetailsStepValues, IOrganizationSignUpFlowValues>
> = observer(({
    values,
    update,
    submit,
    canSubmit,
    validation,
    allValues
}) => {

    /********* React hooks *********/

    const classes = useStyles();
    const controller = useMainOrganizationDetailsController(values, allValues, update, submit);

    /********* Render *********/

    return (
        <Fragment>
            <OrganizationSignUpHeader />
            <OrganizationPrimaryDetailsForm
                values={controller.values}
                onChange={(patch) => {
                    controller.onChange(patch);
                    update(patch); // sync with Flow
                }}
                onSubmit={controller.onSubmit}
                isSubmitting={controller.isSubmitting}
                error={controller.error}
                fieldErrors={controller.fieldErrors}
            />
            <Divider className={classes.divider} />
            <DemoRequest />
        </Fragment>
    );
});
